import React from 'react';
import { connect } from 'react-redux';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import { getPanels } from '_helpers';
import { ObservationGaitGaitDescription } from './ObservationGaitGaitDescription'
import { ObservationGaitGaitCycle } from './ObservationGaitGaitCycle'
import { ObservationGaitGaitAnalysis } from './ObservationGaitGaitAnalysis'
import { ObservationGaitAbnormalGait } from './ObservationGaitAbnormalGait'
import { ObservationGaitAssistiveDevice } from './ObservationGaitAssistiveDevice'
import { ObservationGaitStairNegotiation } from './ObservationGaitStairNegotiation'

const components = {
    ObservationGaitGaitDescription,
    ObservationGaitGaitCycle,
    ObservationGaitGaitAnalysis,
    ObservationGaitAbnormalGait,
    ObservationGaitAssistiveDevice,
    ObservationGaitStairNegotiation,
}

class PatientCareCenterNoteObjectiveObsGait extends React.Component {

    renderChild(name, mopno) {
        const Child = components[name];
        return Child === undefined ? <span key={name} mopno={mopno} /> : <Child key={name} mopno={mopno} />;
    }


    render() {
        if (this.props.panels.length > 0) {
            return (
                <PatientCareCenterNoteSection id='obj_obs_gait' name='Gait' level={2} noChildPadding={true}>
                    {
                        Object.keys(this.props.panels)
                            .map(key => {
                                return this.renderChild(this.props.panels[key].MOPNAME, this.props.panels[key].MOPNO);
                            })

                    }
                </PatientCareCenterNoteSection>
            );
        } else {
            return (
                <span />
            )
        }
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;

    return {
        noteId: noteId,
        panels: getPanels(noteId, 'Observation', 'Gait')
    };
}

const connectedPatientCareCenterNoteObjectiveObsGait = connect(mapStateToProps)(PatientCareCenterNoteObjectiveObsGait);
export { connectedPatientCareCenterNoteObjectiveObsGait as PatientCareCenterNoteObjectiveObsGait };

